/**
 * Integration catalog enums, ported from the Ember
 * `app/utils/integrations/static-integrations.ts`. Ported as `as const`
 * objects + derived union types (Hydra convention — no code-emitting TS
 * `enum`s), preserving the exact string values the backend and catalog rely on.
 */

export const IntegrationType = {
  experiment: 'Experiment',
  native: 'Native',
  partnerBuilt: 'Partner-built',
  zapier: 'Zapier',
  nativeDataOut: 'NativeDataOut',
  nonExistent: 'Non-existent',
  connectPartner: 'Connect-partner',
  pipelinesSource: 'Source',
  pipelinesDestination: 'Destination',
  // used only for UI purposes to filter out: Existing Integrations
  existing: 'Existing',
} as const;
export type IntegrationType = (typeof IntegrationType)[keyof typeof IntegrationType];

export const PipelinesIntegrationType = {
  pipelineSource: 'PipelinesSource',
  pipelinesDestination: 'PipelinesDestination',
} as const;
export type PipelinesIntegrationType = (typeof PipelinesIntegrationType)[keyof typeof PipelinesIntegrationType];

export const ConnectionType = {
  direct: 'Direct',
  developer: 'Developer',
  webhook: 'Webhook',
  zapier: 'Zapier',
} as const;
export type ConnectionType = (typeof ConnectionType)[keyof typeof ConnectionType];

export const ConnectionStatus = {
  connected: 'connected',
  disconnected: 'disconnected',
  disabled: 'disabled',
  needsAttention: 'needs_attention',
  noRecentData: 'no_recent_data',
  authenticationError: 'authentication_error', // deprecated
  configurationError: 'configuration_error', // deprecated
  error: 'error',
  multiple: 'multiple',
} as const;
export type ConnectionStatus = (typeof ConnectionStatus)[keyof typeof ConnectionStatus];

export const ConnectionStatusText: Record<ConnectionStatus, string> = {
  [ConnectionStatus.connected]: 'Connected',
  [ConnectionStatus.disconnected]: 'Disconnected',
  [ConnectionStatus.disabled]: 'Disabled',
  [ConnectionStatus.needsAttention]: 'Needs attention',
  [ConnectionStatus.noRecentData]: 'No recent data',
  [ConnectionStatus.error]: 'Error',
  [ConnectionStatus.authenticationError]: 'Authentication error',
  [ConnectionStatus.configurationError]: 'Configuration error',
  [ConnectionStatus.multiple]: 'Multiple',
};

export const IntegrationCategory = {
  advertising: 'Advertising',
  analytics: 'Analytics',
  api: 'API',
  databases: 'Database & data warehouse',
  dataManagement: 'Data management',
  leadGeneration: 'Lead generation',
  MessagingChannelTypes: 'Message channels',
  surveys: 'Surveys',
} as const;
export type IntegrationCategory = (typeof IntegrationCategory)[keyof typeof IntegrationCategory];

export const IntegrationSyncEnabledStatusMessage = {
  exporting: 'Exporting Customer.io data to a bucket',
  paused: 'Sync is paused',
} as const;
export type IntegrationSyncEnabledStatusMessage =
  (typeof IntegrationSyncEnabledStatusMessage)[keyof typeof IntegrationSyncEnabledStatusMessage];

export const DataFlow = {
  in: 'in',
  out: 'out',
  channel: 'channel',
} as const;
export type DataFlow = (typeof DataFlow)[keyof typeof DataFlow];
